import React from 'react'

import type { CallToActionBlock as CTABlockProps } from '@/payload-types'

import RichText from '@/components/RichText'
import { CMSLink } from '@/components/Link'
import { Reveal } from '@/components/Reveal'

export const CallToActionBlock: React.FC<CTABlockProps> = ({ links, richText }) => {
  return (
    <Reveal>
      {/* Figma CTA Block 87:7425 — outer frame: pt section/NONE (0), pb section/xs (32),
          inner container: 1px theme/border (#e0dfe0) top rule + pt gap/gap-8 (32).
          Two equal top-aligned columns — LEFT = heading (Headings/headlineMd, responsive
          via .prose h3 → --text-display-xl), RIGHT = body copy + button stacked at
          gap/gap-6 (24). Column gap: gap-16 (64) desktop / gap-8 (32) tablet;
          mobile stacks at gap-6 (24). The richText wrapper is `display: contents` so the
          heading and paragraph become grid items directly — one CMS field, two columns. */}
      <div className="mx-auto max-w-[var(--container-content)] px-[var(--spacing-container)] pb-[var(--spacing-section-xs)]">
        <div className="grid items-start gap-6 border-t border-border pt-8 md:grid-cols-2 md:gap-x-8 lg:gap-x-16">
          {richText && (
            <RichText
              className="contents [&_h3]:font-display [&_h3]:text-brand [&_h3]:!tracking-[var(--text-display-xl--letter-spacing)] [&_h3]:!mb-0 [&_h3+p]:!mt-0 [&_p]:md:col-start-2 [&_p]:!text-body-md [&_p]:!font-light"
              data={richText}
              enableGutter={false}
            />
          )}
          <div className="flex flex-col items-start gap-4 md:col-start-2">
            {(links || []).map(({ link }, i) => {
              return <CMSLink key={i} {...link} appearance={link.appearance || 'default'} />
            })}
          </div>
        </div>
      </div>
    </Reveal>
  )
}
